/* Accepted Phase 1 drift, applied only to existing native material interiors.
   The hero adapter remains the sole owner of powder motion. */
(() => {
 window.__henceNativeMaterial?.dispose();
 const controller=new AbortController(),signal=controller.signal;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),forced=matchMedia('(forced-colors: active)');
 const selector='.hq .hq-liquid,.hq-actions .product-form__submit,.hq-gift,.hq-community,.hence-quiet-header .hqh-shop,.hence-quiet-header svg.hqh-logo,.hence-signature-footer .hsf-panel,.hence-native-hero .opening-copy h1 mark>.liquid-heading,.hence-native-hero .opening-actions .button';
 const states=new Map();
 let frame=0,last=0,lastPaint=0,lastY=scrollY,impulse=0,pointer=null,suspended=false,active=!!document.querySelector('.hence-native-hero');
 const allowed=()=>active&&!reduced.matches&&!forced.matches&&!document.hidden&&!suspended;
 function clear(s){s.node.style.removeProperty('--p1-x');s.node.style.removeProperty('--p1-y');s.node.style.removeProperty('--p1-powder-x');s.node.style.removeProperty('--p1-powder-y');}
 function stop(reset){
  if(frame)cancelAnimationFrame(frame);frame=0;last=0;lastPaint=0;impulse=0;pointer=null;lastY=scrollY;
  if(reset)states.forEach(s=>{s.phase=0;clear(s);});
 }
 function start(){if(allowed()&&[...states.values()].some(s=>s.visible)&&!frame)frame=requestAnimationFrame(draw);}
 function draw(now){
  frame=0;if(!allowed()){stop(true);return;}
  if(lastPaint&&now-lastPaint<32){start();return;}
  const dt=last?Math.min(.08,(now-last)/1000):0;last=now;lastPaint=now;impulse*=Math.exp(-dt*2.5);
  states.forEach(s=>{
   if(!s.visible)return;s.phase+=dt;
   const wave=Math.sin(s.phase*.34),cross=Math.sin(s.phase*.23),gain=s.panel?1:s.nav?.28:.45;
   const x=(cross*2.4+impulse*.7)*gain,y=(wave*3.4+impulse*1.8)*gain;
   s.node.style.setProperty('--p1-x',`${x.toFixed(3)}px`);
   s.node.style.setProperty('--p1-y',`${y.toFixed(3)}px`);
   // The community speckle layer travels with the panel, as in the oracle (phase1-material.js).
   if(s.community){s.node.style.setProperty('--p1-powder-x',`${(x*.58).toFixed(3)}px`);s.node.style.setProperty('--p1-powder-y',`${(y*1.35).toFixed(3)}px`);}
  });start();
 }
 const observer=new IntersectionObserver(entries=>{
  entries.forEach(entry=>{const s=states.get(entry.target);if(s)s.visible=entry.isIntersecting&&entry.boundingClientRect.width>0&&entry.boundingClientRect.height>0;});
  if(![...states.values()].some(s=>s.visible))stop(false);else start();
 },{threshold:0});
 function remove(node){const s=states.get(node);if(!s)return;observer.unobserve(node);clear(s);delete node.dataset.henceMaterial;states.delete(node);}
 function refresh(){
  active=!!document.querySelector('.hence-native-hero');
  states.forEach(s=>{if(!s.node.isConnected)remove(s.node);});
  if(!active){stop(true);return;}
  document.querySelectorAll(selector).forEach(node=>{
   if(states.has(node))return;
   const s={node,panel:node.matches('.hq-gift,.hq-community,.hsf-panel'),community:node.matches('.hq-community'),nav:node.matches('svg'),visible:false,phase:0};
   states.set(node,s);node.dataset.henceMaterial=s.panel?'panel':s.nav?'nav':'fill';observer.observe(node);
  });start();
 }
 addEventListener('scroll',()=>{const delta=scrollY-lastY;lastY=scrollY;if(!allowed())return;impulse=Math.max(-3,Math.min(3,impulse-delta*.012));start();},{passive:true,signal});
 addEventListener('pointermove',event=>{
  if(event.pointerType==='touch'||!allowed())return;
  if(pointer){const dy=event.clientY-pointer.y,dx=event.clientX-pointer.x;impulse=Math.max(-3,Math.min(3,impulse+(dy+dx*.25)*.008));}
  pointer={x:event.clientX,y:event.clientY};start();
 },{passive:true,signal});
 addEventListener('pointerout',event=>{if(!event.relatedTarget)pointer=null;},{passive:true,signal});
 function preference(){stop(true);start();}
 reduced.addEventListener('change',preference,{signal});forced.addEventListener('change',preference,{signal});
 document.addEventListener('visibilitychange',preference,{signal});
 addEventListener('pagehide',()=>{suspended=true;stop(true);},{signal});
 addEventListener('pageshow',()=>{suspended=false;refresh();},{signal});
 document.addEventListener('shopify:section:unload',event=>{
  states.forEach(s=>{if(event.target.contains(s.node))remove(s.node);});
  if(event.target.matches('.hence-native-hero')||event.target.querySelector('.hence-native-hero')){active=false;stop(true);}
  else if(![...states.values()].some(s=>s.visible))stop(false);
 },{signal});
 document.addEventListener('shopify:section:load',refresh,{signal});
 window.__henceNativeMaterial={dispose:()=>{controller.abort();stop(true);observer.disconnect();states.forEach(s=>{delete s.node.dataset.henceMaterial;});states.clear();}};
 refresh();
})();
